import { useEffect, useRef, useState } from "react";
// TODO: Replace with backend endpoint
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ExportUsers() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isAdmin = localStorage.getItem('isAdmin');

    const tableRef = useRef(null);

    const [users, setUsers] = useState<any[]>([]);

    useEffect(() => {
        const requestOptionsPost = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/stats/users', requestOptionsPost)
            .then(response => {
                if (response.status !== 200) {
                    navigate('/');
                }
                return response.json();
            })
            .then(data => {
                setUsers(data);
            });
    }, []);

    return (
        <div>
                {/* TODO: Replace with backend endpoint for Excel export */}
                <button disabled>{ t("Export Users") } (Pendiente)</button>

                <table  ref={tableRef}>
                 <tbody>
                    <tr>
                        <th>{ t("ID") }</th>
                        <th>{ t("Email") }</th>
                        <th>{ t("Role") }</th>
                        <th>{ t("Teaching location") }</th>
                        <th>{ t("Teaching model") }</th>
                        <th>{ t("Teaching framework") }</th>
                        <th>{ t("Country") }</th>
                        <th>{ t("Region") }</th>
                        <th>{ t("Organization") }</th>
                        <th>{ t("Teaching years") }</th>
                        <th>{ t("Level") }</th>
                    </tr>
                    { users.map((u: any) => {
                        return <tr>
                            <td>{ u.id }</td>
                            <td>{ u.email }</td>
                            <td>{ u.role }</td>
                            <td>{ u.teaching_location.join('|') }</td>
                            <td>{ u.teaching_model.join('|') }</td>
                            <td>{ u.teaching_framework.join('|') }</td>
                            <td>{ u.country }</td>
                            <td>{ u.region }</td>
                            <td>{ u.organization }</td>
                            <td>{ u.teaching_years }</td>
                            <td>{ u.level }</td>
                        </tr>;
                    })}
                  </tbody>
                </table>

            </div>);
}